import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalOpenerOptions } from '../modal-opener/modal-opener.component';

@Component({
  selector: 'div[data-component-type=info]',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoComponent implements OnInit {

  @Input() information: any
  @Input() opener!: ModalOpenerOptions

  constructor() { }

  ngOnInit(): void {
  }

}

export interface InfoOptions {
  id: string,
  type: 'info-component',
  information: any,
  opener?: ModalOpenerOptions,
  presence: boolean
}